/**
 * 获取后端约定测试环境请求生产接口拿到参数的固定请求头 只在测试环境生效
 * 不能用环境变量判断 需要根据域名判断是否为生产环境
 *  */
export default function getIgnoreTokenHeader(): Record<string, string> {
    const isProd =
        typeof window !== 'undefined' &&
        (['www.ecoflow.com', 'localhost', 'release-new-product-prod.iot-ecoflow.com'].includes(window.location.hostname) ||
            window.location.hostname.startsWith('10.20.'));

    if (isProd) return {};

    return {
        'X-Enable-Ignore-Token': `npa134zbcfx2b242sgk72ekdutcxbid2${new Date().getTime()}`,
    };
}
